import { motion } from "framer-motion";
import {
  Tent, Lightbulb, Storefront, Truck, MonitorPlay,
  IdentificationCard, Globe, PenNib, ArrowUpRight,
} from "@phosphor-icons/react";

const services = [
  {
    icon: Tent, title: "Allestimento Fiere", big: true,
    text: "Stand fieristici personalizzati, progettati per attirare visitatori e montati dai nostri team in ogni fiera. Tu accogli i clienti, al resto pensiamo noi.",
    img: "/images/allestimento-fiere.jpg",
  },
  {
    icon: Lightbulb, title: "Insegne Luminose",
    text: "Insegne a LED e cassonetti luminosi che rendono il tuo punto vendita riconoscibile giorno e notte.",
    img: "/images/insegne-luminose.jpg",
  },
  {
    icon: Storefront, title: "Vetrofanie",
    text: "Vetrine che vendono: decorazioni adesive su misura per promozioni, privacy e identità del tuo negozio.",
    img: "/images/vetrofanie.jpg",
  },
  {
    icon: Truck, title: "Decorazione Automezzi",
    text: "Car wrapping e flotte aziendali brandizzate: i tuoi veicoli diventano pubblicità in movimento, ovunque vadano.",
    img: "/images/decorazione-automezzi.jpg",
  },
  {
    icon: MonitorPlay, title: "Ledwall",
    text: "Schermi LED di grande formato per eventi, fiere e retail: impatto visivo massimo, installazione chiavi in mano.",
    img: "/images/ledwall.webp",
  },
  {
    icon: IdentificationCard, title: "Coordinato Aziendale",
    text: "Biglietti da visita, carta intestata, brochure e modulistica: un'immagine coerente in ogni dettaglio cartaceo.",
    img: "/images/coordinato-aziendale.jpeg",
  },
  {
    icon: Globe, title: "Siti Web",
    text: "Web design moderno e orientato ai risultati: la tua presenza online curata come la tua vetrina fisica.",
    img: "/images/siti-web.webp",
  },
  {
    icon: PenNib, title: "Progettazione Grafica", big: true,
    text: "Loghi, layout e identità visive che restano impressi. Il nostro studio trasforma le tue idee in un brand riconoscibile al primo sguardo.",
    img: "/images/progettazione-grafica.webp",
  },
];

export const Services = () => (
  <section id="servizi" className="py-24 lg:py-32 bg-zinc-50" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
            className="text-xs tracking-[0.35em] uppercase text-zinc-500 mb-6"
          >
            Cosa Facciamo
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display font-semibold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl text-zinc-900"
            style={{ wordSpacing: "0.12em" }}
            data-testid="services-title"
          >
            Otto modi per farti<br /><span className="text-gradient">notare.</span>
          </motion.h2>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-zinc-500 max-w-sm text-sm leading-relaxed"
        >
          Un unico partner per ogni esigenza di comunicazione visiva: dal progetto grafico all'installazione finale.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {services.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.a
              href="#contatti"
              key={s.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
              className="group relative overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-sm hover:shadow-xl hover:shadow-fuchsia-500/10 transition-shadow duration-500"
              data-testid={`service-card-${i}`}
            >
              <div className="relative h-56 sm:h-64 overflow-hidden">
                <img src={s.img} alt={s.title} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <span className="absolute top-4 left-4 p-3 rounded-xl bg-white/90 backdrop-blur-sm border border-zinc-200 text-[#00A5C8] group-hover:text-[#FF007F] transition-colors duration-500">
                  <Icon size={26} weight="duotone" />
                </span>
              </div>
              <div className="p-7 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display font-medium text-xl tracking-tight text-zinc-900">{s.title}</h3>
                  <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{s.text}</p>
                </div>
                <ArrowUpRight size={20} className="shrink-0 mt-1 text-zinc-300 group-hover:text-zinc-900 group-hover:translate-x-1 group-hover:-translate-y-1 transition-[color,transform] duration-300" />
              </div>
            </motion.a>
          );
        })}
      </div>
    </div>
  </section>
);
